import { useRef, useState, type PointerEvent, type ReactNode } from "react";

const SCHWELLE = 72;

/**
 * Zeile, die sich nach links wischen lässt. Beim Loslassen jenseits der
 * Schwelle löst sie aus, sonst federt sie zurück.
 *
 * Bewusst über Pointer-Events statt einer Gestenbibliothek: es ist eine
 * Richtung, eine Schwelle, und jede Abhängigkeit weniger startet schneller.
 * Die Aktion ist zusätzlich über einen Knopf erreichbar, damit sie nicht
 * allein an der Geste hängt (Regel 8).
 */
export function SwipeRow({ onSwipe, children }: { onSwipe: () => void; children: ReactNode }) {
  const [offset, setOffset] = useState(0);
  const start = useRef<number | null>(null);

  function begin(event: PointerEvent<HTMLDivElement>) {
    start.current = event.clientX;
  }

  function move(event: PointerEvent<HTMLDivElement>) {
    if (start.current === null) return;
    const delta = event.clientX - start.current;
    setOffset(Math.min(0, Math.max(delta, -140)));
  }

  function end() {
    if (start.current === null) return;
    const ausgeloest = offset <= -SCHWELLE;
    start.current = null;
    setOffset(0);
    if (ausgeloest) onSwipe();
  }

  return (
    <div className="relative overflow-hidden rounded-[var(--radius-md)]">
      <div className="absolute inset-y-0 right-0 flex items-center pr-4 text-sm font-semibold text-honey">Nicht da</div>
      <div
        onPointerDown={begin}
        onPointerMove={move}
        onPointerUp={end}
        onPointerCancel={end}
        style={{ transform: `translateX(${String(offset)}px)`, touchAction: "pan-y" }}
        className="relative bg-paper transition-transform"
      >
        {children}
      </div>
    </div>
  );
}
